import React from 'react';
import {
    Row,
    Col,
} from 'react-bootstrap';

const ViewMode = props=> {
    return (
        <Col sm={3} key={props.index} className="imgMargin">
            <a href={props.item.file_name} target="_blank">
                <div key={props.index} className="img" style={{backgroundImage: `url('${props.item.thumbnail}')`}}></div>
            </a>
        </Col>
    );
}

const EditMode = props=> {
    return (
        <Col sm={3} key={props.index} className="imgMargin">
            <a onClick={event => props.fileDelete(event ,props.item.file_name, props.type)} className="deleteFile">
                <span className="glyphicon glyphicon-remove-circle"></span>
            </a>
            <div className="img" style={{backgroundImage: `url('${props.item.thumbnail}')`}}></div>
        </Col>
    );
}

export class FilesPreview extends React.Component {
    imgsPreview(){
        let imgsPreview = '';//沒有圖片, 回傳空字串
        let {
            images,
            enableEdit,
            fileDelete,
        } = this.props;
        if(images!==0){//如果有圖片,顯示所有圖片
            imgsPreview = images.map((item,index)=>{
                return (
                    !enableEdit?
                    <ViewMode
                        key={index} 
                        item={item}
                        index={index} />
                    :
                    <EditMode
                        key={index}  
                        item={item}
                        index={index}
                        fileDelete={fileDelete} 
                        type="img"
                    />
                )    
            });
        }
        return imgsPreview;
    }
    pdfsPreview(){
        let pdfsPreview = '';//沒有圖片, 回傳空字串
        let {
            pdfs,
            enableEdit,
            fileDelete,
        } = this.props;
        if(pdfs.length!==0){//如果有PDF,顯示所有PDF
            pdfsPreview = pdfs.map((item,index)=>{

                return (
                    !enableEdit?
                    <ViewMode
                        key={index} 
                        item={item}
                        index={index} />
                    :
                    <EditMode
                        key={index}  
                        item={item}
                        index={index}
                        fileDelete={fileDelete}
                        type="pdf"
                    />
                ) 
            });
        }
        return pdfsPreview;
    }
    videosPreview(){
        let videosPreview = '';//沒有影片, 回傳空字串
        let {
            videos,
            enableEdit,
            fileDelete,
        } = this.props;
        if(videos.length!==0){//如果有影片,顯示所有影片
            videosPreview = videos.map((item,index)=>{
                return (
                    !enableEdit?
                    <ViewMode
                        key={index} 
                        item={item}
                        index={index} />
                    :
                    <EditMode
                        key={index}  
                        item={item}
                        index={index}
                        fileDelete={fileDelete}
                        type="video"
                    />
                )    
            });
        }
        return videosPreview;
    }
    render(){
        let {
            images,
            pdfs,
            videos,
            enableEdit,
        } = this.props;
        let imgsPreview = this.imgsPreview();
        let pdfsPreview = this.pdfsPreview();
        let videosPreview = this.videosPreview();
        /*
            1.檢視畫面:
              (1)有沒有附件? 有的話 顯示previewZone, 沒有的話, 顯示"暫無附件"
              (2)有附件的話, 點選附件會開新分頁檢視附件
            2.編輯畫面:
              (1)有沒有附件? 有的話 顯示previewZone, 沒有的話, 顯示""空字串
              (2)有附件的話, 點選附件會顯示刪除按鈕
        */
        return(
            <div>
                {
                    (images.length===0 && pdfs.length===0 && videos.length===0) ?
                    <div>{ enableEdit ? "" : "暫無附件" }</div>
                     : 
                    <Row className="previewZone">
                        <div className="imgsPreview row previewBg">
                            <div className="catagory">圖片</div>
                            {imgsPreview}
                        </div>
                        <div className="pdfsPreview row previewBg">
                            <div className="catagory">PDF</div>
                            {pdfsPreview}
                        </div>
                        <div className="videosPreview row previewBg">
                            <div className="catagory">影片</div>
                            {videosPreview}
                        </div>
                    </Row>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/commonComponents/FilesPreviewCt.jsx